import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Box,
  Chip,
  IconButton,
  Divider,
} from "@mui/material"
import { Person as PersonIcon, Star as StarIcon, Close as CloseIcon } from "@mui/icons-material"
import StaffRatingModal from "./StaffRatingModal"
import styles from "./HiredApplicants.module.css"
import { rateStaff } from "../../../Services/BusinessOwner"

interface HiredCandidate {
  user_id: number
  full_name: string
  email_address: string
  phone_number: string
  location_city: string
  location_country: string
  total_years_experience: string
  jobTitle: string
  jobRoleID: string
  status: {
    employed: number
    interviewed: number
    screened: number
  }
}

interface HiredApplicantsListProps {
  open: boolean
  onClose: () => void
  project: {
    project_id: string
    project_name: string
    jobRoles: {
      jobRoleID: string
      jobTitle: string
      candidates: any[]
    }[]
  }
  hiredCandidates: HiredCandidate[]
}

const HiredApplicantsList: React.FC<HiredApplicantsListProps> = ({ open, onClose, project, hiredCandidates }) => {
  const [selectedCandidate, setSelectedCandidate] = useState<HiredCandidate | null>(null)
  const [ratingModalOpen, setRatingModalOpen] = useState(false)

  const handleCandidateClick = (candidate: HiredCandidate) => {
    setSelectedCandidate(candidate)
    setRatingModalOpen(true)
    // onClose()
  }

//   const handleRatingSubmit = async (ratingData: any) => {
//     console.log("Rating submitted:", ratingData)
//     setRatingModalOpen(false)
//     setSelectedCandidate(null)
    //   }

    const handleRateStaff = async (ratingData: any) => {
        try {
          console.log("Rating staff:", ratingData)
          await rateStaff(ratingData)
          // You could add a success notification here
          console.log("Staff rating submitted successfully")
        } catch (error) {
          console.error("Failed to submit staff rating:", error)
          throw error
        }
      }
    

    const handleRatingSubmit = async (ratingData: any) => {
        try {
            // await rateStaff(selectedCandidate?.user_id, ratingData)
            await rateStaff(ratingData)
            console.log("Rating submitted:", ratingData)
            setRatingModalOpen(false)
            setSelectedCandidate(null)
        } catch (error) {
            console.error("Error submitting rating:", error)
        }
    }

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        className={styles.dialog}
        PaperProps={{
          className: styles.dialogPaper,
        }}
      >
        <DialogTitle className={styles.dialogTitle}>
          <Box className={styles.titleContent}>
            <Typography variant="h5" className={styles.title}>
              Hired Staff - {project.project_name}
            </Typography>
            <Typography variant="body2" className={styles.subtitle}>
              {hiredCandidates.length} hired candidate{hiredCandidates.length !== 1 ? "s" : ""}
            </Typography>
          </Box>
          <IconButton onClick={onClose} className={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className={styles.dialogContent}>
          <List className={styles.candidatesList}>
            {hiredCandidates.map((candidate, index) => (
              <React.Fragment key={candidate.user_id}>
                <ListItem className={styles.candidateItem} onClick={() => handleCandidateClick(candidate)}>
                  <ListItemAvatar>
                    <Avatar className={styles.avatar}>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box className={styles.candidateHeader}>
                        <Typography variant="h6" className={styles.candidateName}>
                          {candidate.full_name}
                        </Typography>
                        <Chip label={candidate.jobTitle || "Staff Member"} size="small" className={styles.roleChip} />
                      </Box>
                    }
                    secondary={
                      <Box className={styles.candidateDetails}>
                        <Typography variant="body2" className={styles.contactInfo}>
                          {candidate.email_address} • {candidate.phone_number}
                        </Typography>
                        <Typography variant="body2" className={styles.locationInfo}>
                          {candidate.location_city}, {candidate.location_country} • {Number(candidate.total_years_experience).toFixed(0)} years experience
                        </Typography>
                      </Box>
                    }
                  />
                  <Box className={styles.rateButton}>
                    <StarIcon className={styles.starIcon} />
                    <Typography variant="body2">Rate Staff</Typography>
                  </Box>
                </ListItem>
                {index < hiredCandidates.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </DialogContent>
      </Dialog>

      {selectedCandidate && (
        <StaffRatingModal
          open={ratingModalOpen}
          onClose={() => {
            setRatingModalOpen(false)
            setSelectedCandidate(null)
          }}
          candidate={selectedCandidate}
          project={project}
          onSubmitRating={handleRatingSubmit}
        />
      )}
    </>
  )
}

export default HiredApplicantsList
